import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import {
  isScopedMessagesQueryKey,
  messagesApiQueryKeys,
} from '@/features/dashboard/messages/api/messagesApi.queryKeys.ts';
import messagesApi from '@/features/dashboard/messages/api/messagesApi.ts';
import { invalidateAttentionQueries } from '@/utils/invalidateAttentionQueries.ts';

/**
 * Archiwizacja gasi sprawę „Niewysłane wiadomości” — backend liczy tam wyłącznie wiadomości
 * niezarchiwizowane. Z `tourId` panel spraw tego wyjazdu, stojący tuż obok listy, gubi ją od razu.
 */
const useDeleteMessage = (tourId?: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (id) => messagesApi.deleteMessage(id),
    onSuccess: () => {
      toast.success('Wiadomość została usunięta');
      return Promise.all([
        queryClient.invalidateQueries({
          queryKey: messagesApiQueryKeys.all(),
        }),
        queryClient.invalidateQueries({
          predicate: (query) => isScopedMessagesQueryKey(query.queryKey),
        }),
        invalidateAttentionQueries(queryClient, tourId),
      ]);
    },
    onError: (error: Error) => {
      toast.error('Nie udało się usunąć wiadomości', {
        description: error.message,
      });
    },
  });
};

export default useDeleteMessage;
